import axios from "axios";
import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { baseURL } from "../config";
import { useSearchParams } from "react-router-dom";

function TeamCards({ managerId }) {
  const [teamMembers, setTeamMembers] = useState([]);
  const role = localStorage.getItem("userrole");
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(0);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const period = `${selectedPeriod}${currentYear}`;


  const nextYear = currentYear + 1;
  let selyear = nextYear;
  const handleYearChange = (event) => {
    let yr = event.target.value;

    setSelectedYear(yr);
    setSelectedPeriod("Select");
    setTeamMembers([]);
  };
  const handlePeriodChange = async (event) => {
    let pd = event.target.value;

    setSelectedPeriod(pd);
    try {
      const response = await axios.get(
        `${baseURL}/getteamAppraisallist?id=` +
          managerId +
          "&mon=" +
          pd +
          "&yr=" +
          selectedYear
      );
      const data = response.data;
      let arrTeamdata = data.team;
      setTeamMembers(arrTeamdata);
      setSelectedYear(selectedYear);
      console.log(data);
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setSelectedPeriod("April");
        setSelectedYear(currentYear);
        const response = await axios.get(
          `${baseURL}/getteamAppraisallist?id=` +
            managerId +
            "&mon=April&yr=" +
            currentYear
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);
        setSelectedYear(currentYear);
        console.log(data);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    //   alert(managerId);
    // if (managerId) {managerId
    fetchData();
    //}
  }, [managerId]);

  return (
    <div className="row m-3">
      <h4>My Team Appraisal </h4>
      {/* <h6> <label onClick={setMonth("Apr")}>For  April {currentYear}</label> / For  Dec {currentYear}</h6> */}
      <p>You can conduct the appraisal for each of your team members.</p>
      <table>
        <tr>
          <td className="col-md-1">
            <label>Step1: Select Year:</label>
            <select onChange={handleYearChange}>
              <option>Select Year</option>
              <option value={currentYear - 1}>{currentYear - 1}</option>
              <option selected value={currentYear}>
                {currentYear}
              </option>
              <option value={nextYear}>{nextYear}</option>
            </select>{" "}
            <label>Step2: Select Period:</label>
            <select value={selectedPeriod} onChange={handlePeriodChange}>
              <option value="Select">Select Period</option>
              <option selected value={"April"}>
                {" "}
                April-{selectedYear}
              </option>
              <option value={"December"}> December-{selectedYear}</option>
            </select>
          </td>{" "}
          <td className="col-md-1"></td>
        </tr>
      </table>
      <br></br>

      {teamMembers && teamMembers.length > 0 ? (
        teamMembers.map((member, index) => (
          <Card
            key={index}
            className="m-2 Regular shadow p-1"
            style={{ width: "30%", minHeight: "300px", maxHeight: "500px" }}
          >
            <Card.Img
              className="m-auto pt-3"
              style={{ width: "100px" }}
              variant="top center"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
            />
            <Card.Body className="p-1">
              <Card.Title
                className="text-center"
                style={{ "font-size": "15px" }}
              >
                <div>
                  {member?.FirstName} {member?.LastName}- {member.employeeid}
                </div>
              </Card.Title>
              <Card.Text className="text-center">
                {/* <p className="card_des">Has Supervisor:{member.has_supervisor}</p> */}
                {/* <p className="card_des">Appraisal Initiated:{member.has_appraisal}</p> */}

                {member.has_appraisal === "yes" ? (
                  member.status === "Manager Submitted" ||
                  member.status === "Approver Approved" ||
                  member.status === "HR Approved" ||
                  member.status === "Employee Accepted" ||
                  member.status === "Employee Appealed" ||
                  member.status === "Supervisor Submitted" ||
                  member.status === "Approver Rejected" ? (
                    <p className="card_des">
                      <a
                        href={`/viewemployessappraisal?id=${member.employeeid}&mon=${selectedPeriod}&yr=${selectedYear}&periods=${period}`}
                        className="text-black"
                      >
                        <div
                          className="btn btn-warning text-dark border-1 badge"
                          style={{
                            position: "absolute",
                            bottom: "30px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontSize: "14px", 
                            padding: "6px 10px", 
                            borderRadius: "4px", 
                          }}
                        >
                          View Appraisal
                        </div>
                      </a>
                    </p>
                  ) : (
                    <p className="card_des">
                      <a
                        href={`/appraisalteammember?id=${member.employeeid}&mon=${selectedPeriod}&yr=${selectedYear}&periods=${period}`}
                        className="text-black"
                      >
                        <div
                          className="btn btn-success text-light border-1 badge"
                          style={{
                            position: "absolute",
                            bottom: "30px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontSize: "14px", // Increases the text size
                            padding: "6px 10px", // Increases the size of the badge
                            borderRadius: "4px", // Optional: Makes the badge look larger and rounded
                          }}
                        >
                          Start Appraisal
                        </div>
                      </a>
                    </p>
                  )
                ) : (
                  <p
                    className="card_des"
                    style={{ outline: "2px dashed #000" }}
                  >
                    Appraisal not initiated
                  </p>
                )}
                <div>
                  <p
                    className="skill_card_status"
                    style={{ "font-size": "14px" }}
                  >
                    Status :{" "}
                    {member.has_appraisal === "yes" ? (
                      <span>{member.status || "Not Started"}</span>
                    ) : (
                      "Not Started"
                    )}
                  </p>
                  <p
                    className="skill_card_status"
                    style={{ "font-size": "14px" }}
                  >
                    Period : <span>{member.term}</span>
                  </p>
                </div>
              </Card.Text>
            </Card.Body>
          </Card>
        ))
      ) : (
        <h5>Appraisal for the selected period is not initiated</h5>
      )}
    </div>
  );
}

export default TeamCards;
